(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pc-product-wizard"] && !Shopify.designMode) return;
  try {
    
(function () {
  function boot() {
    document.querySelectorAll('.pc-pw__gallery').forEach(function (gallery) {
      if (gallery.dataset.arrowsReady) return;
      var thumbs = Array.from(gallery.querySelectorAll('[data-pw-thumb]'));
      var image = gallery.querySelector('[data-pw-main-img]');
      var prev = gallery.querySelector('[data-gallery-prev]');
      var next = gallery.querySelector('[data-gallery-next]');
      if (!image || !prev || !next || thumbs.length < 2) return;
      gallery.dataset.arrowsReady = 'true';
      var initial = thumbs.findIndex(function(t) { return t.dataset.src === image.getAttribute('src'); });
      var index = initial < 0 ? 0 : initial;
      function show(i) {
        index = (i + thumbs.length) % thumbs.length;
        image.removeAttribute('srcset');
        image.src = thumbs[index].dataset.src;
        image.alt = thumbs[index].querySelector('img').alt || image.alt;
        thumbs.forEach(function(t, n) { t.classList.toggle('is-active', n === index); t.setAttribute('aria-current', n === index ? 'true' : 'false'); });
        var strip = thumbs[index].parentElement;
        if (strip.scrollWidth > strip.clientWidth) strip.scrollLeft = thumbs[index].offsetLeft - strip.offsetLeft - (strip.clientWidth - thumbs[index].offsetWidth) / 2;
      }
      prev.addEventListener('click', function() { show(index - 1); });
      next.addEventListener('click', function() { show(index + 1); });
      thumbs.forEach(function(t, n) { t.addEventListener('click', function() { show(n); }); });
      gallery.addEventListener('keydown', function(e) {
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.preventDefault(); show(index + (e.key === 'ArrowLeft' ? -1 : 1)); }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
